// extracted by mini-css-extract-plugin
module.exports = {"animateShake":"styles_animateShake__hV2T3","shake":"styles_shake__BE5gF"};